import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class DeveloperSubscriptionEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "DeveloperSubscription";
        this.primaryEnterpriseComponent = "DeveloperSubscription";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "DeveloperSubscription";
        eom.enterpriseComponent = "DeveloperSubscription";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "DeveloperSubscriptionCommunication";
        eom.enterpriseComponent = "DeveloperSubscriptionCommunication";
        eom.relationship = "DeveloperSubscriptionDeveloperSubscriptionCommunication";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default DeveloperSubscriptionEnterpriseObjectMetadata;